import { useSyncExternalStore } from 'react';
import { isDocumentLanguage, type DocumentLanguage } from './useLanguage';

/**
 * Limba DOCUMENTULUI — concept distinct de limba meniului (§1.0c).
 *
 * Reguli:
 * - NU scrie în `localStorage['hepaskin-language']` (aceea e limba meniului);
 * - NU apelează `setLanguage` din `useLanguage`;
 * - are propria stare, sincronizată între consumatori (selector + export).
 */
const DEFAULT_DOCUMENT_LANGUAGE: DocumentLanguage = 'ro';

let activeDocumentLanguage: DocumentLanguage = DEFAULT_DOCUMENT_LANGUAGE;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const setDocumentLanguage = (language: DocumentLanguage) => {
  if (!isDocumentLanguage(language)) return;
  if (activeDocumentLanguage === language) return;
  activeDocumentLanguage = language;
  notify();
};

export const useDocumentLanguage = (): {
  language: DocumentLanguage;
  setLanguage: (lang: DocumentLanguage) => void;
} => {
  const language = useSyncExternalStore(
    subscribe,
    () => activeDocumentLanguage,
    () => DEFAULT_DOCUMENT_LANGUAGE,
  );

  return {
    language,
    setLanguage: setDocumentLanguage,
  };
};

/** Doar pentru teste — readuce starea la valoarea implicită. */
export const resetDocumentLanguage = () => {
  activeDocumentLanguage = DEFAULT_DOCUMENT_LANGUAGE;
  notify();
};
